(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[90319],{

/***/ 36820:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goal/[goalSlug]/[goalUID]/test-series/all",
      function () {
        return __webpack_require__(39075);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54540);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);




var H1 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("h1", {
    target: "e15q8xmq0",
    label: "H1"
})("font-weight:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.BOLD */ .F3.Pl, ";font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.H1 */ .F3.H1, ";line-height:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.HEADER_LINE_HEIGHT */ .F3.rm, ";color:", function(param) {
    var color = param.color;
    return color;
}, ";margin:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_0B */ .t8.NE, ";@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.tablet */ .AV.tablet, "){font-size:24px;}@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.mobile */ .AV.mobile, "){font-size:28px;line-height:120%;}", function(param) {
    var lineClamp = param.lineClamp;
    return lineClamp ? _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lineClampStyle */ .Z.lineClampStyle(lineClamp) : null;
});
/* harmony default export */ __webpack_exports__["Z"] = (H1);
H1.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    lineClamp: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number)
};
H1.defaultProps = {
    color: "var(--color-text-primary)",
    lineClamp: null
};


/***/ }),

/***/ 82034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54540);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);




var H3 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("h3", {
    target: "e1121ic30",
    label: "H3"
})("font-weight:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.BOLD */ .F3.Pl, ";font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.H3 */ .F3.H3, ";line-height:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.PARA_LINE_HEIGHT */ .F3.MA, ";color:", function(param) {
    var color = param.color;
    return color;
}, ";margin:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_0B */ .t8.NE, ";@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.tablet */ .AV.tablet, "){font-size:24px;}@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.mobile */ .AV.mobile, "){font-size:22px;}", function(param) {
    var lineClamp = param.lineClamp;
    return lineClamp ? _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lineClampStyle */ .Z.lineClampStyle(lineClamp) : null;
});
/* harmony default export */ __webpack_exports__["Z"] = (H3);
H3.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    lineClamp: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number)
};
H3.defaultProps = {
    color: "var(--color-text-primary)",
    lineClamp: null
};


/***/ }),

/***/ 52236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);



var getStyling = function(type) {
    var styling = {
        filled: {
            Bg: "var(--color-base-fill)",
            Text: "var(--color-base-1)",
            paddingHorizontal: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_2B */ .t8.Rw,
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.H7 */ .F3.H7
        },
        hollow: {
            Bg: "var(--color-shadow)",
            Text: "var(--color-text-primary)",
            paddingHorizontal: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_6 */ .t8.A1,
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.EXTRA_SMALL */ .F3.y2
        },
        transparent: {
            Bg: "var(--color-base-1)",
            Text: "var(--color-i-blue)",
            paddingHorizontal: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_0B */ .t8.NE,
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.H7 */ .F3.H7
        },
        live: {
            Bg: "var(--color-i-red)",
            Text: "var(--color-i-white)",
            paddingHorizontal: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_2B */ .t8.Rw,
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.H7 */ .F3.H7
        },
        disabled: {
            Bg: "var(--color-base-1)",
            Text: "var(--color-text-secondary)",
            paddingHorizontal: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_0B */ .t8.NE,
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.EXTRA_SMALL */ .F3.y2
        },
        discount: {
            Bg: "var(--color-i-orange-16)",
            Text: "var(--color-i-orange-1)",
            paddingHorizontal: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_2B */ .t8.Rw,
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.H7 */ .F3.H7
        },
        alert: {
            Bg: "var(--color-base-1)",
            Text: "var(--color-i-red)",
            paddingHorizontal: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_0B */ .t8.NE,
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.H7 */ .F3.H7
        },
        success: {
            Bg: "var(--color-i-green)",
            Text: "var(--color-base-1)",
            paddingHorizontal: "10px",
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.EXTRA_SMALL */ .F3.y2
        }
    };
    return styling[type];
};
var semiBold = [
    "filled",
    "live",
    "alert"
];
var Tags = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("span", {
    target: "e13dpfl00",
    label: "Tags"
})("background-color:", function(param) {
    var type = param.type, bgColor = param.bgColor;
    var ref;
    return bgColor || ((ref = getStyling(type)) === null || ref === void 0 ? void 0 : ref.Bg);
}, ";color:", function(param) {
    var type = param.type;
    var ref;
    return (ref = getStyling(type)) === null || ref === void 0 ? void 0 : ref.Text;
}, ";font-size:", function(param) {
    var type = param.type;
    return getStyling(type).fontSize;
}, ";font-weight:", function(param) {
    var type = param.type;
    return semiBold.includes(type) ? _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.SEMIBOLD */ .F3.rX : _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.BOLD */ .F3.Pl;
}, ";padding:", function(param) {
    var type = param.type;
    var ref;
    return "".concat(_styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_6 */ .t8.A1, " ").concat((ref = getStyling(type)) === null || ref === void 0 ? void 0 : ref.paddingHorizontal);
}, ";border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_1B */ .t8.MK, ";display:inline-block;text-transform:uppercase;line-height:1;");
/* harmony default export */ __webpack_exports__["Z"] = (Tags);
Tags.propTypes = {
    type: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf([
        "filled",
        "hollow",
        "transparent",
        "live",
        "disabled",
        "discount",
        "alert",
        "success"
    ]),
    bgColor: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
Tags.defaultProps = {
    type: "transparent",
    bgColor: null
};


/***/ }),

/***/ 27300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52420);
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89374);
/* harmony import */ var _context_IsPageInReduxContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9716);




var PageReduxProvider = function(param) {
    var children = param.children, initialReduxState = param.initialReduxState;
    var store = (0,src_redux__WEBPACK_IMPORTED_MODULE_1__/* .getStore */ .b)(initialReduxState);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_context_IsPageInReduxContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        store: store,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(react_redux__WEBPACK_IMPORTED_MODULE_0__/* .Provider */ .zt, {
            store: store,
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PageReduxProvider);


/***/ }),

/***/ 88738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ln": function() { return /* binding */ useDispatchToStore; },
  "nZ": function() { return /* binding */ useSelectorToStore; },
  "hM": function() { return /* binding */ useSelectorWithShallowEqual; }
});

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(52420);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(82492);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
;// CONCATENATED MODULE: ./src/utils/fetchDataFromNormalizer.js

/* eslint-disable no-plusplus */ 
var tableIndex = {
    user: "users",
    author: "users",
    course: "courses",
    item: "items",
    topology: "topologies",
    feedrow: "feedrows",
    question: "questions",
    batch: "batches",
    doubt: "doubts",
    doubtSolution: "doubtSolutions",
    template: "templates",
    batchGroup: "batchGroups"
};
var fetchDataFromNormalizer = function(data, state) {
    var newData = data;
    if (data && typeof data === "object" && Object.keys(data)) {
        var dataKeys = Object.keys(data);
        if (dataKeys.length > 0) {
            var i = 0;
            while(i < dataKeys.length){
                if (dataKeys[i] in tableIndex && typeof newData[dataKeys[i]] !== "object") {
                    var stateData = state[tableIndex[dataKeys[i]]].data[newData[dataKeys[i]]];
                    if (dataKeys.length > 1) {
                        newData = merge_default()(newData, (0,_define_property/* default */.Z)({}, dataKeys[i], fetchDataFromNormalizer(stateData, state)));
                    } else {
                        newData = fetchDataFromNormalizer(stateData, state);
                    }
                } else {
                    newData = merge_default()(newData, (0,_define_property/* default */.Z)({}, dataKeys[i], fetchDataFromNormalizer(newData[dataKeys[i]], state)));
                }
                i += 1;
            }
        }
    }
    return newData;
};
/* harmony default export */ var utils_fetchDataFromNormalizer = (fetchDataFromNormalizer);

;// CONCATENATED MODULE: ./src/hooks/reduxHooks.js



var useSelectorToStore = function(mapProps) {
    var needShallowEqualCheck = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var data = (0,es/* useSelector */.v9)(mapProps, needShallowEqualCheck ? es/* shallowEqual */.wU : undefined);
    var stateData = (0,es/* useStore */.oR)().getState(); // Hack --- need to change with useSelector #todo (Priya / Saurabh)
    return utils_fetchDataFromNormalizer(cloneDeep_default()(data), cloneDeep_default()(stateData));
};
var useDispatchToStore = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    return dispatch;
};
var useSelectorWithShallowEqual = function(selector) {
    return (0,es/* useSelector */.v9)(selector, es/* shallowEqual */.wU);
};


/***/ }),

/***/ 6858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable react-hooks/exhaustive-deps */ 
var useFirstRenderSkip = function(callback, deps) {
    var isFirstRenderingDone = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isFirstRenderingDone.current) callback();
        else isFirstRenderingDone.current = true;
    }, deps);
};
/* harmony default export */ __webpack_exports__["Z"] = (useFirstRenderSkip);


/***/ }),

/***/ 39075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ test_series_all; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/seo/index.jsx + 2 modules
var seo = __webpack_require__(14432);
// EXTERNAL MODULE: ./src/components/Container/SeeAll/TestSeriesListing/Common/TopBar.jsx
var TopBar = __webpack_require__(71000);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(52420);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./src/components/Base/H3/H3.jsx
var H3 = __webpack_require__(82034);
// EXTERNAL MODULE: ./src/components/Base/P1/P1.jsx
var P1 = __webpack_require__(85620);
// EXTERNAL MODULE: ./src/components/Composite/InfiniteList/InfiniteList.jsx + 1 modules
var InfiniteList = __webpack_require__(88074);
// EXTERNAL MODULE: ./src/components/Composite/TestSeriesCard/TestSeriesCard.jsx
var TestSeriesCard = __webpack_require__(13272);
// EXTERNAL MODULE: ./src/components/Composite/Dropdown/Dropdown.jsx
var Dropdown = __webpack_require__(8477);
// EXTERNAL MODULE: ./src/redux/actions/plusCourses.js
var plusCourses = __webpack_require__(51856);
// EXTERNAL MODULE: ./src/constants/empty.js
var empty = __webpack_require__(59375);
;// CONCATENATED MODULE: ./src/redux/selectors/quizzes.js

var getIsFetching = function(param) {
    var quizzes = param.quizzes;
    return quizzes.isFetching;
};
var getTestSeries = function(param) {
    var paginator = param.paginator;
    return paginator.testSeries || empty/* emptyObject */.FD;
};
var getGtpTestSeriesData = function(param) {
    var quizzes = param.quizzes;
    return quizzes === null || quizzes === void 0 ? void 0 : quizzes.gtpTestSeries;
};

// EXTERNAL MODULE: ./src/hooks/reduxHooks.js + 1 modules
var reduxHooks = __webpack_require__(88738);
// EXTERNAL MODULE: ./src/hooks/useWindowSize.js
var useWindowSize = __webpack_require__(50420);
// EXTERNAL MODULE: ./src/hooks/useRefreshDataOnGloUpdate.js
var useRefreshDataOnGloUpdate = __webpack_require__(41700);
// EXTERNAL MODULE: ./src/utils/imageHelper.js
var imageHelper = __webpack_require__(48821);
// EXTERNAL MODULE: ./src/utils/feedTypeHelper.js
var feedTypeHelper = __webpack_require__(99682);
// EXTERNAL MODULE: ./src/utils/pushRoute.js
var pushRoute = __webpack_require__(751);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/components/Container/SeeAll/utils.js
var utils = __webpack_require__(28806);
// EXTERNAL MODULE: ./src/components/Container/SeeAll/constants.js
var constants = __webpack_require__(69524);
// EXTERNAL MODULE: ./src/components/Container/SeeAll/TestSeriesListing/Common/Header.jsx
var Header = __webpack_require__(84474);
// EXTERNAL MODULE: ./src/components/Container/SeeAll/TestSeriesListing/Common/Loader.jsx
var Loader = __webpack_require__(45470);
;// CONCATENATED MODULE: ./src/components/Container/SeeAll/TestSeriesListing/Test/Landing.jsx
























var NoCourses = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H3/* default */.Z, {
    target: "e1kxozin0",
    label: "NoCourses"
})("margin-top:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";margin-bottom:", styleConstants/* Spacings.SPACING_5B */.t8.zj, ";color:var(--color-text-primary);");
var linkStyle = "margin-bottom: ".concat(styleConstants/* Spacings.SPACING_6B */.t8.BY, ";");
var DropdownWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1kxozin1",
    label: "DropdownWrapper"
})("grid-column:span 18;display:grid;grid-template-columns:repeat(18,1fr);grid-column-gap:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";margin-bottom:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){grid-column:span 11;grid-column-gap:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";grid-template-columns:repeat(10,1fr);}");
var StyledDropdown = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Dropdown/* default */.Z, {
    target: "e1kxozin2",
    label: "StyledDropdown"
})("@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){margin-bottom:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";grid-column:span 11;height:", styleConstants/* Spacings.SPACING_12B */.t8.SL, ";}");
var Empty = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1kxozin3",
    label: "Empty"
})("grid-column:span 18;text-align:center;margin-top:", styleConstants/* Spacings.SPACING_24B */.t8.j2, ";");
var EmptyImage = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("img", {
    target: "e1kxozin4",
    label: "EmptyImage"
})("user-drag:none;user-select:none;");
var TestListingLanding = function(param) {
    var dataAnalytics = param.dataAnalytics, showAll = param.showAll, maxLimit = param.maxLimit;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var _query = router.query, goalUID = _query.goalUID, goalSlug = _query.goalSlug, testType = _query["test-type"], pathname = router.pathname;
    var testSeriesData = (0,reduxHooks/* useSelectorToStore */.nZ)(getTestSeries);
    var isMobile = (0,useWindowSize/* default */.Z)().isMobile;
    var initalType = (0,utils/* getValidTestType */.$q)(testType);
    var ref = (0,react.useState)(initalType), testSeriesType = ref[0], setTestSeriesType = ref[1];
    var optionSelect = function(option) {
        dispatch((0,plusCourses/* fetchTestSeries */.nU)(goalUID, option.value));
        setTestSeriesType(option.value);
        (0,pushRoute/* default */.Z)({
            pathname: pathname,
            query: {
                goalUID: goalUID,
                goalSlug: goalSlug,
                "test-type": option.value
            }
        }, undefined, {
            shallow: true
        });
    };
    var getSelectedOption = function() {
        return constants/* OPTIONS.find */.JY.find(function(option) {
            return option.value === testSeriesType;
        });
    };
    var data = testSeriesData[(0,feedTypeHelper/* getTestSeriesFeedKey */.P_)(goalUID, testSeriesType)];
    var testSeriesList = showAll ? data.results : data.results.slice(0, maxLimit);
    var isFetching = data === null || data === void 0 ? void 0 : data.isFetching;
    var isEmpty = !isFetching && !testSeriesList.length;
    var isLessThenLimit = isEmpty ? true : data.results.length <= maxLimit;
    var loadMore = function(resetWithoutEmpty, forceReset) {
        return dispatch((0,plusCourses/* fetchTestSeries */.nU)(goalUID, testSeriesType, true, resetWithoutEmpty, forceReset));
    };
    (0,useRefreshDataOnGloUpdate/* default */.Z)(function() {
        return loadMore(true, true);
    });
    var renderTestSeries = function(test, index) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TestSeriesCard/* default */.Z, {
            test: test,
            linkStyle: linkStyle,
            index: index,
            dataAnalytics: dataAnalytics
        }, test.uid);
    };
    var renderContent = function() {
        if (isEmpty) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Empty, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyImage, {
                        src: (0,imageHelper/* getImage */.gJ)("empty.svg"),
                        alt: "empty-content"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoCourses, {
                        children: "No test series found"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(P1/* default */.Z, {
                        color: "var(--color-text-secondary)",
                        children: "The educator hasn\u2019t added any courses yet. Try changing the filters"
                    })
                ]
            });
        }
        if (showAll) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfiniteList["default"], {
                data: data,
                loadMore: loadMore,
                _renderItem: renderTestSeries,
                gridColumn: "5/15"
            });
        }
        if (isFetching) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loader/* default */.Z, {});
        }
        return testSeriesList.map(function(test, index) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TestSeriesCard/* default */.Z, {
                test: test,
                linkStyle: linkStyle,
                index: index,
                dataAnalytics: dataAnalytics
            }, test.uid);
        });
    };
    var seeAllHref = isLessThenLimit || showAll ? null : "/goal/".concat(goalSlug, "/").concat(goalUID, "/test-series/all?test-type=").concat(testSeriesType);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header/* default */.Z, {
                label: "Test Series",
                seeAllHref: seeAllHref
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropdownWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDropdown, {
                    options: constants/* OPTIONS */.JY,
                    onOptionClick: optionSelect,
                    selectedOption: getSelectedOption(),
                    menuWidth: isMobile ? "100%" : "176px"
                })
            }),
            renderContent()
        ]
    });
};
/* harmony default export */ var Landing = (TestListingLanding);
TestListingLanding.propTypes = {
    maxLimit: (prop_types_default()).number,
    showAll: (prop_types_default()).bool,
    dataAnalytics: (prop_types_default()).string
};
TestListingLanding.defaultProps = {
    maxLimit: 6,
    showAll: true,
    dataAnalytics: ""
};

// EXTERNAL MODULE: ./src/components/Container/SeeAll/TestSeriesListing/Common/Breadcrumbs.jsx
var Breadcrumbs = __webpack_require__(7010);
;// CONCATENATED MODULE: ./src/components/Container/SeeAll/TestSeriesListing/AllTestSeries.jsx




var AllTestSeries = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopBar/* default */.Z, {
                breadcrumbs: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumbs/* default */.Z, {
                    type: Breadcrumbs/* default.TYPE.ONLY_TEST_SERIES */.Z.TYPE.ONLY_TEST_SERIES
                }),
                title: "Test series"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Landing, {
                dataAnalytics: "testSeries",
                showAll: true
            })
        ]
    });
};
/* harmony default export */ var TestSeriesListing_AllTestSeries = (AllTestSeries);

// EXTERNAL MODULE: ./src/redux/selectors/topologies.js
var topologies = __webpack_require__(83109);
// EXTERNAL MODULE: ./src/seo/goal/subGoal.js
var subGoal = __webpack_require__(94004);
// EXTERNAL MODULE: ./src/redux/actions/topologies.js
var actions_topologies = __webpack_require__(62282);
// EXTERNAL MODULE: ./src/stores/sidenav.js
var sidenav = __webpack_require__(19204);
// EXTERNAL MODULE: ./src/constants/segment.js
var segment = __webpack_require__(17579);
// EXTERNAL MODULE: ./src/utils/setupInitialProps.js
var setupInitialProps = __webpack_require__(57714);
// EXTERNAL MODULE: ./src/layout/index.jsx + 26 modules
var layout = __webpack_require__(41566);
// EXTERNAL MODULE: ./src/components/Container/App/PageReduxProviderWrapper.jsx
var PageReduxProviderWrapper = __webpack_require__(27300);
// EXTERNAL MODULE: ./src/stores/AppCommonData.jsx + 1 modules
var AppCommonData = __webpack_require__(83995);
;// CONCATENATED MODULE: ./src/pages/goal/[goalSlug]/[goalUID]/test-series/all.jsx




















var TestSeries = function() {
    var router = (0,next_router.useRouter)();
    var goalUID = router.query.goalUID;
    var ref = (0,AppCommonData/* usePageSeoContent */.tS)(), title = ref.title, description = ref.description;
    var goalInfo = (0,reduxHooks/* useSelectorWithShallowEqual */.hM)(function(state) {
        return (0,topologies/* getTopology */.hP)(state, goalUID);
    });
    var ref1 = goalInfo || empty/* emptyObject */.FD, goalSlug = ref1.goalSlug, uid = ref1.uid, thumbnail = ref1.thumbnail, ogImage = ref1.ogImage;
    var metaTitle = title || "All Test Series | ".concat(goalInfo.title, " | Unacademy");
    var canonicalURL = "https://unacademy.com/goal/".concat(goalSlug, "/").concat(uid, "/test-series/all");
    (0,sidenav/* useSetSelectedNav */.WF)("test-series");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(seo/* default */.Z, {
                title: metaTitle,
                description: description,
                openGraph: {
                    title: title,
                    description: description,
                    images: [
                        {
                            url: ogImage || thumbnail
                        }
                    ],
                    url: canonicalURL
                },
                schema: (0,subGoal/* default */.Z)({
                    goal: goalInfo,
                    description: description,
                    subGoal: {
                        name: "Test series",
                        link: "test-series"
                    }
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                    children: metaTitle
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TestSeriesListing_AllTestSeries, {})
        ]
    });
};
TestSeries.pageInfo = {
    isMWebSupported: true,
    name: segment/* ALL_TEST_SERIES */.BRR,
    layoutOptions: {
        hideFooter: true,
        showPlusNav: true
    },
    isCMSMeta: true
};
TestSeries.getInitialProps = (0,setupInitialProps/* default */.Z)(function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var store, query, goalUID, testType, initalType, promises;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    store = param.store, query = param.query;
                    goalUID = query.goalUID, testType = query["test-type"];
                    initalType = (0,utils/* getValidTestType */.$q)(testType);
                    promises = [
                        store.dispatch((0,plusCourses/* fetchTestSeries */.nU)(goalUID, initalType))
                    ];
                    if (!(0,topologies/* getTopology */.hP)(store.getState(), goalUID)) {
                        promises.push(store.dispatch((0,actions_topologies/* fetchTopologyInfo */.Yn)(goalUID)));
                    }
                    _ctx.next = 7;
                    return Promise.all(promises);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_) {
        return _ref.apply(this, arguments);
    };
}(), TestSeries.pageInfo);
/* harmony default export */ var test_series_all = (TestSeries);
TestSeries.Layout = layout/* default */.Z;
TestSeries.Wrapper = PageReduxProviderWrapper["default"];


/***/ }),

/***/ 51856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K3": function() { return /* binding */ fetchPlusHomeFeed; },
/* harmony export */   "ms": function() { return /* binding */ fetchSeeAllFeedExtraBlockInfo; },
/* harmony export */   "nU": function() { return /* binding */ fetchTestSeries; }
/* harmony export */ });
/* unused harmony exports fetchFreeRelatedCourses, fetchSimilarPlusCourses, fetchNextTrack */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _utils_paginateAction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72894);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94336);
/* harmony import */ var _schemas__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93010);






var getTestSeries = function(goalUID, type, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .plusCoursesTypes.FETCH_TEST_SERIES */ .oj.FETCH_TEST_SERIES,
            endpoint: next,
            method: "get",
            key: "testSeries_".concat(goalUID, "_").concat(type),
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_1__/* .paginatorListSchema */ .EH,
            directPaginatedEntity: true,
            entityType: "course"
        };
    };
};
var fetchTestSeries = function(goalUID) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, nextPage = arguments.length > 2 ? arguments[2] : void 0, resetWithoutEmpty = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, forceReset = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("v1/uplus/subscription/test_series/?goal_uid=".concat(goalUID, "&type=").concat(type, "&limit=12"), getTestSeries(goalUID, type, resetWithoutEmpty), "testSeries", "testSeries_".concat(goalUID, "_").concat(type), resetWithoutEmpty, forceReset)(nextPage);
};
var getPlusHomeFeed = function(goalUid, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .plusCoursesTypes.FETCH_PLUS_HOME_FEED */ .oj.FETCH_PLUS_HOME_FEED,
            endpoint: next,
            method: "get",
            key: goalUid,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_1__/* .paginatorListSchema */ .EH,
            directPaginatedEntity: true,
            entityType: "feedrow",
            processData: function(data) {
                var newData = data;
                newData.results = newData.results.map(function(resultItem) {
                    if (resultItem.type === "all_topic_groups") {
                        var item = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, resultItem), {
                            data: resultItem.data.map(function(topicGroup) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, topicGroup), {
                                    plusCourseCount: topicGroup.count,
                                    count: null
                                });
                            })
                        });
                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, item), {
                            key: "".concat(goalUid, "_plus")
                        });
                    }
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, resultItem), {
                        key: "".concat(goalUid, "_plus")
                    });
                });
                return newData;
            }
        };
    };
};
var getFreeRelatedCourses = function(lessonUID) {
    var resetWithoutEmpty = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return function(next) {
        return {
            type: itemTypes.FETCH_FREE_RELATED_SPECIAL_ITEMS,
            endpoint: next,
            method: "get",
            key: lessonUID,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: paginatorListSchema,
            directPaginatedEntity: true,
            entityType: "feedrow",
            processData: function(data) {
                var newData = data;
                newData.results = newData.results.map(function(resultItem) {
                    return _object_spread_props(_object_spread({}, resultItem), {
                        key: lessonUID,
                        data: resultItem.data.map(function(dataRow) {
                            return _object_spread({}, dataRow, dataRow.programme);
                        })
                    });
                });
                return newData;
            }
        };
    };
};
var fetchFreeRelatedCourses = function(param, nextPage) {
    var lessonUID = param.lessonUID, authorUID = param.authorUID, goalUID = param.goalUID, topicUID = param.topicUID, resetWithoutEmpty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return paginateAction("v2/post/".concat(lessonUID, "/related_special_items?author_uid=").concat(authorUID, "&goal_uid=").concat(goalUID, "&topic_uid=").concat(topicUID), getFreeRelatedCourses(lessonUID, resetWithoutEmpty), "freeRelatedCourses", lessonUID, resetWithoutEmpty)(nextPage);
};
var fetchPlusHomeFeed = function(goalUid, nextPage) {
    var resetWithoutEmpty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, queryParams = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("v1/uplus/subscription/home/?goal_uid=".concat(goalUid, "&v=10").concat(queryParams ? "&".concat(queryParams) : ""), getPlusHomeFeed(goalUid, resetWithoutEmpty), "plusHomePageFeed", goalUid, resetWithoutEmpty)(nextPage);
};
var getSeeAllExtraBlockInfoURL = function(seeAllType, topologyUid, blockType) {
    var url = null;
    if (seeAllType === "specialClass") {
        url = "v1/uplus/special_class/extra_block_info/?goal_uid=".concat(topologyUid, "&block=").concat(blockType);
    } else if (seeAllType === "goal") {
        url = "v1/uplus/subscription/feed_block_extra_info/?topology_uid=".concat(topologyUid, "&block_type=").concat(blockType);
    } else if (seeAllType === "freeCourses") {
        url = "v1/feeds/user/extra_block_info/?goal_uid=".concat(topologyUid, "&block_type=").concat(blockType);
    } else if (seeAllType === "search") {
        url = "v1/search_v3/extra_block_info/?block_type=".concat(blockType);
    }
    return url;
};
var fetchSeeAllFeedExtraBlockInfo = function(topologyUid, blockType, seeAllType) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .plusCoursesTypes.FETCH_SEE_ALL_EBINFO */ .oj.FETCH_SEE_ALL_EBINFO,
            endpoint: getSeeAllExtraBlockInfoURL(seeAllType, topologyUid, blockType),
            method: "get",
            topologyUid: topologyUid,
            blockType: blockType,
            seeAllType: seeAllType
        });
    };
};
var fetchSimilarPlusCourses = function(courseUID) {
    return function(dispatch) {
        return dispatch({
            type: plusCoursesTypes.FETCH_SIMILAR,
            endpoint: "v2/collection/".concat(courseUID, "/similar_courses/"),
            method: "get",
            key: courseUID,
            schema: new schema.Object({
                feedrow: feedRowSchema
            }),
            entityType: "feedrow",
            processData: function(data) {
                var newData = _object_spread_props(_object_spread({}, data), {
                    extra_block_info: _object_spread_props(_object_spread({}, data.extra_block_info), {
                        entity_type: "Course"
                    })
                });
                newData.data = data.data.map(function(course) {
                    return _object_spread({}, course, course.programme);
                });
                newData.key = courseUID;
                return newData;
            }
        });
    };
};
var fetchNextTrack = function(courseUID) {
    return function(dispatch) {
        return dispatch({
            type: plusCoursesTypes.FETCH_NEXT_TRACK,
            endpoint: "v1/collection/".concat(courseUID, "/next_track/"),
            method: "get",
            key: courseUID,
            schema: new schema.Object({
                nextTrack: {
                    item: itemSchema
                },
                activeQuizSession: {
                    item: itemSchema
                }
            }),
            processData: function(data) {
                var activeQuizSession = data.active_quiz_session;
                if (activeQuizSession) {
                    delete activeQuizSession.collection;
                    delete activeQuizSession.programme;
                }
                var newData = {
                    nextTrack: data.next_track ? {
                        item: _object_spread_props(_object_spread({}, data.next_track), {
                            type: "post"
                        })
                    } : null,
                    activeQuizSession: activeQuizSession ? {
                        item: _object_spread_props(_object_spread({}, activeQuizSession), {
                            type: "quiz"
                        })
                    } : null
                };
                return newData;
            }
        });
    };
};


/***/ }),

/***/ 29630:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var breadCrumbSchema = function(breads) {
    var schema = {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList"
    };
    schema.itemListElement = breads.filter(function(bread) {
        return bread.name && bread.url;
    }).map(function(bread, index) {
        return {
            "@type": "ListItem",
            position: index + 1,
            name: bread.name,
            item: bread.url
        };
    });
    return schema;
};
/* harmony default export */ __webpack_exports__["Z"] = (breadCrumbSchema);


/***/ }),

/***/ 83909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var zustand_shallow__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60374);

// Selector ref: https://github.com/pmndrs/zustand/wiki/Auto-Generating-Selectors
// Shallow store ref: https://github.com/pmndrs/zustand#selecting-multiple-state-slices
// To get the property/action: const propertyName = useStore.use.propertyName()
function createStoreSelectors(store) {
    store.use = {};
    Object.keys(store.getState()).forEach(function(key) {
        var selector = function(state) {
            return state[key];
        };
        store.use[key] = function() {
            return store(selector, zustand_shallow__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);
        };
    });
    return store;
}
/* harmony default export */ __webpack_exports__["Z"] = (createStoreSelectors);


/***/ }),

/***/ 97903:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var getItemFromSessionStorage = function(item) {
    try {
        return sessionStorage.getItem(item);
    } catch (e) {
        return null;
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (getItemFromSessionStorage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [35303,86924,82492,52420,25675,96523,61608,41664,63953,74635,64097,21322,26184,9720,46571,89374,94336,4392,72047,56015,41566,32410,17562,1987,49774,92888,40179], function() { return __webpack_exec__(36820); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);